/** The two color themes the app can render. Dark is wired but not yet designed. */
export type Theme = 'light' | 'dark';

/**
 * Reflect the active theme onto the document by setting `data-theme` on the
 * root `<html>` element. All color tokens are CSS variables keyed off this
 * attribute (see `src/index.css`), so flipping it re-themes the whole app
 * without touching markup. Mirrors how the app shell toggles `is-authenticated`
 * on `<html>`. No-op outside a DOM (e.g. unit tests without jsdom).
 */
export function applyTheme(theme: Theme): void {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', theme);
}
